import styled from "styled-components";
import { Flex, Input, Slider } from "@evergis/ui";
import { AttributeBlank, AttributesList } from "../DialogComponents/styled";

export const Separator = styled.span`
  :after {
    content: "|";
    padding: 0 0.5rem;
    color: ${({ theme: { palette } }) => palette.elementDeep};
  }
`;

export const AttributesContainer = styled.div`
  margin-top: 2rem;
`;

export const Descr = styled.div`
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme: { palette } }) => palette.textSecondary} !important;
`;

export const UploadAttributesContainer = styled.div`
  width: 100%;

  ${AttributesList} {
    ${AttributeBlank} {
      padding-top: 0;
      padding-right: 0;
      padding-bottom: 0;
      overflow-y: visible;
    }
  }
`;

export const UploadDescription = styled(Descr)`
  margin-bottom: 2rem;

  strong {
    font-weight: bold;
    color: rgba(0, 0, 0, 0.87);
  }
`;

export const UploadAttributeColumn = styled(Flex)`
  flex: 1;
  flex-direction: column;
  padding: 0.375rem 0;
`;

export const UploadAttributeType = styled(UploadAttributeColumn)`
  align-self: stretch;
  border-right: 1px ${({ theme: { palette } }) => palette.elementDeep} solid;
  margin-right: 0 !important;
  padding-top: 0.375rem;
`;

export const UploadAttributeValue = styled(UploadAttributeColumn)`
  position: relative;
  margin: 0.375rem;
  padding: 0 0.875rem 0.875rem;

  :after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ theme: { palette } }) => palette.elementDark};
    opacity: 0.6;
  }

  span {
    z-index: 1;
    position: relative;
    width: 100%;
  }
`;

export const UploadAttributeInput = styled(Input)`
  :not(:disabled) {
    background-color: #fff;
  }
`;

export const UploadProgressTitle = styled.div`
  margin: 6rem 0 1rem;
`;

export const UploadReadyContainer = styled.div`
  margin: 6rem 0 5rem;
`;

export const Label = styled.label`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.palette.textSecondary};
  margin-bottom: 0.75rem;
`;

export const MaxZoomLevelContainer = styled.div`
  padding-left: 1.75rem;
  margin-top: 2.625rem;
`;

export const ZoomSlider = styled(Slider)`
  margin-left: 0.25rem;
`;

export const ZoomTypeContainer = styled(Flex)`
  margin-left: 1.75rem;
  flex-direction: column;
  align-items: center;
`;

export const ZoomType = styled.div<{ img: string }>`
  width: 4rem;
  height: 4rem;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("${({ img }) => img}");
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  margin-bottom: 0.75rem;
`;
